var render = function (_h,_vm) {var _c=_vm._c;return _c('span',[(_vm.props.type === 'ring')?_c('div',{staticClass:"lds-ring"},[_c('div'),_c('div'),_c('div'),_c('div')]):_c(_vm.$options.components.N8nIcon,{tag:"component",attrs:{"icon":"spinner","size":_vm.props.size,"spin":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }